import request from './request';

// 获取热血江湖游戏随机列表
export function getGameList() {
  return request({
    url: '/box/v1/rxjhGames',
    method: 'get',
  })
}

// 获取游戏业务排行榜数据
interface IGameRankParams {
  gameIds: string
  gameType: number // 传奇是1/传世游戏是2/7热江
}
export function getGameRank(params: IGameRankParams) {
  return request({
    url: '/box/v1/todayGamesBizExtend',
    method: 'get',
    params
  })
}
